import type { ReviewInsights } from './product-types';

export function hasReviewRating(insights?: ReviewInsights): boolean {
  return Boolean(insights && insights.ratingCount > 0 && typeof insights.rating === 'number'
    && Number.isFinite(insights.rating) && insights.rating >= 0 && insights.rating <= 5);
}

export function reviewCountLabel(total: number, selected: number): string {
  return total > selected ? `${total.toLocaleString()} 条香评 · 精选 ${selected} 条` : `${selected} 条香评`;
}
